import React from 'react';
import { motion } from 'framer-motion';
import { Bus, GraduationCap, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const SikhHeritageForwardCTA = () => {
  return <section className="py-24 md:py-32 bg-black relative overflow-hidden" data-id="element-1707">
      {/* Background with a warm ivory/gold glow to contrast the dark theme */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-black to-black z-0" data-id="element-1708"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-1709">
        <div className="bg-gradient-to-br from-[#1a150e] to-black border border-amber-400/30 rounded-2xl p-8 md:p-16 overflow-hidden relative" data-id="element-1710">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-1711"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-1712"></div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-1713">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1714">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/10 border border-amber-400/20 mb-6" data-id="element-1715">
                <GraduationCap className="w-4 h-4 text-amber-400" data-id="element-1716" />
                <span className="text-amber-400 text-xs tracking-[0.2em] uppercase font-medium" data-id="element-1717">
                  Student Access Program
                </span>
              </div>

              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-1718">
                Sponsor a Bus. <br data-id="element-1719" />
                <span className="text-amber-400" data-id="element-1720">Pay Heritage Forward.</span>
              </h2>

              <p className="text-white/70 text-lg font-light leading-relaxed mb-8" data-id="element-1721">
                Help bring students from public schools, Gurdwara youth groups,
                and diaspora communities to experience their history alive. Your
                sponsorship funds transportation and access during Sikh Heritage
                Month and beyond.
              </p>

              <Link to="/sikh-heritage-forward" className="inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-500 text-black px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-1722">
                Become a Sponsor
                <ArrowRight className="w-4 h-4" data-id="element-1723" />
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-1724">
              <div className="bg-gradient-to-br from-amber-400/10 to-amber-400/5 border border-amber-400/40 p-6 md:p-8 rounded-xl backdrop-blur-sm text-center flex flex-col items-center justify-center" data-id="element-1725">
                <Bus className="w-10 h-10 text-amber-400 mb-4" data-id="element-1726" />
                <div className="font-serif text-4xl md:text-5xl text-white mb-2" data-id="element-1727">
                  50
                </div>
                <div className="text-amber-100/70 text-xs tracking-wider uppercase font-light" data-id="element-1728">
                  Students per bus
                </div>
              </div>

              <div className="bg-gradient-to-br from-amber-400/10 to-amber-400/5 border border-amber-400/40 p-6 md:p-8 rounded-xl backdrop-blur-sm text-center flex flex-col items-center justify-center" data-id="element-1729">
                <GraduationCap className="w-10 h-10 text-amber-400 mb-4" data-id="element-1730" />
                <div className="font-serif text-4xl md:text-5xl text-white mb-2" data-id="element-1731">
                  12k+
                </div>
                <div className="text-amber-100/70 text-xs tracking-wider uppercase font-light" data-id="element-1732">
                  Students in Year 1
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};